import Vue from 'vue';
import { Component, Prop, Provide, Watch, Inject } from 'vue-property-decorator';
import template from './shippingDetailTruckload.vue';
import { Validator } from 'vee-validate';
import DefaultSelect from '../../../../components/unisDefaultSelect';
import switchBillingToService from '../../../../shared/switchBillingToService';
import tmsServiceBackend from '../../../../services/axios/tmsServiceBackend';
@Component({
    mixins: [template],
    components: {
        DefaultSelect,
    },
})
export default class ShippingDetailTruckload extends Vue {
    /* 页面直接字段 开始 */
    palletDimensions: Array<Object> = [
        {
            type: 1,
            title: 'Pallets: Standard (40" x 48")',
            width: 40,
            length: 48,
            editable: false,
        },
        {
            type: 2,
            title: 'Pallets: (60" x 48")',
            width: 60,
            length: 48,
            editable: false,
        },
        {
            type: 3,
            title: 'Pallets: (48" x 48")',
            width: 48,
            length: 48,
            editable: false,
        },
        {
            type: 4,
            title: 'Other: (enter dimensions)',
            width: 0,
            length: 0,
            editable: true,
        },
    ];
    @Prop()
    productTemplates: any; // product 列表，可能只包含 id, name

    @Prop()
    index: number; // 第几个 product

    @Prop()
    product: any; // 包含该 product 的详细信息，比如长宽高重、class、quantity

    @Prop({ default: false })
    lock: boolean;

    @Prop({ default: 0 })
    total: number;

    /* 页面直接字段 结束 */
    // Data
    palletDimensionsOptions = this.$store.getters.quoteData.palletDimensionsOptions;

    calculateUnitPalletSpace = this.$store.getters.quoteData.calculateUnitPalletSpace;

    getPalletSpace = this.$store.getters.quoteData.getPalletSpace;

    palletSpaceCalculationSettings = this.$store.getters.quoteData.palletSpaceCalculationSettings;

    shipmentDescription_CharacterLimit: number = 50;

    isStackable: boolean = true;

    productClass: Array<string> = [
        '50',
        '55',
        '60',
        '65',
        '70',
        '77',
        '85',
        '92',
        '100',
        '110',
        '125',
        '150',
        '175',
        '200',
        '250',
        '300',
        '400',
    ];

    max_pallet: number | null = null;
    min_pallet: number = 1;

    tooltipMessages: any = {
        width: `Pallet width must be under 96".`,
        length: `Pallet length must be under 96".`,
        height: `Pallet height must be under 108". Don't know the height of your pallets? Since most pallets are on average 48\" in height, we have set this as the default height. Feel free to change it if you know the height of your pallets.`,
        quantity: 'Total pallet positions must be under 15.',
        totalWeight: 'Average weight of each pallet position per line must be under 1,800 lbs.',
        stackable:
            'Can we stack your pallets on top of each other during pickup and/or delivery? We will automatically calculate the number of spaces required.',
        // hazardousMaterial: "Does your shipment contain commodities that are hazardous as defined in the code of Federal Regulation, Title 49, by the US Department of Transportation? If so, you will be charged an additional fee and one of our representatives will contact you to get more information about the contents of the shipment."
    };

    selectProduct = 'empty';
    initProductData = {};

    // Properties

    // inject the validator from parent, parent and child will now share the same validator instance
    @Inject()
    $validator: Validator;

    // computed properties
    get editable() {
        let type = this.product.palletType;

        for (let i = 0; i < this.palletDimensionsOptions.length; i++) {
            if (this.palletDimensionsOptions[i].type == type) {
                return this.palletDimensionsOptions[i].editable;
            }
        }
    }

    get overWeight() {
        let palletSpace = parseInt(this.product.palletSpace);
        let weight = parseFloat(this.product.totalWeight);

        if (palletSpace > 0) {
            let result = weight / palletSpace > 1800;
            this.product.overWeight = result;
            return result;
        } else {
            return false;
        }
    }

    // life cycle methods
    created() {
        this.EventBus.globalEvent = (val: any) => {
            this.switchBillingToService();
        };
        if (this.product.stackable === false) {
            this.product.stackable = 0;
        }
        if (this.product.stackable === true) {
            this.product.stackable = 1;
        }
        this.onPalletWidthChanged(); // when edit, width is changed
    }

    mounted() {
        Object.assign(this.initProductData, this.product);
        this.switchBillingToService();
    }

    async getFacilities(location_id: any) {
        let params = {
            UserID: localStorage.getItem('UserID'),
            UserToken: localStorage.getItem('UserToken'),
            billto_id: location_id,
        };
        tmsServiceBackend.post('/user/palletlimit', params).then(res => {
            this.max_pallet = res.data.data.max_pallet ? res.data.data.max_pallet : null;
            this.min_pallet = res.data.data.min_pallet ? res.data.data.min_pallet : 1;
        });
    }

    switchBillingToService() {
        switchBillingToService.post().then(
            (res: any) => {
                if (res.data.billing) {
                    this.getFacilities(res.data.billing.location_id);
                }
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    updated() {
        // console.log(this.product);
    }
    // life cycle methods

    @Watch('product.palletType')
    onPalletTypeChanged(val: string, oldVal: string, event: any) {
        let dimension = this.$store.getters.palletDimension(val);
        Object.assign(this.product, dimension);
        this.$validator.errors.remove('width' + this.index);
        this.$validator.errors.remove('length' + this.index);
    }

    @Watch('product.selectedPalletDimension')
    onPalletDimensionChanged(val: string, oldVal: string, event: any) {
        let selectedPalletDimension: any = this.palletDimensions.find((o: any) => o.type == val);
        if (
            selectedPalletDimension &&
            selectedPalletDimension.width > 0 &&
            selectedPalletDimension.length > 0 &&
            selectedPalletDimension != 4
        ) {
            this.product.width = selectedPalletDimension.width;
            this.product.length = selectedPalletDimension.length;
        } else {
            this.product.width = null;
            this.product.length = null;
        }
    }

    // @Watch("product.height")
    // onHeightChanged(val: string, oldVal: string) {
    //   let maxHeight = this.palletSpaceCalculationSettings.maxHeight;

    //   if (maxHeight / this.product.height < 2) {
    //     this.product.stackable = 0;
    //     // this.isStackable = false;
    //   } else if (maxHeight / this.product.height >= 2) {
    //     this.product.stackable = 1;
    //     // this.isStackable = true;
    //   }
    //   this.onPalletWidthChanged();
    // }

    @Watch('product.width')
    @Watch('product.length')
    @Watch('product.quantity')
    @Watch('product.stackable')
    onPalletWidthChanged() {
        // calculate pallet space
        if (
            this.product.width > 0 &&
            this.product.length > 0 &&
            this.product.height > 0 &&
            this.product.quantity > 0
        ) {
            let maxHeight = this.palletSpaceCalculationSettings.maxHeight;

            let unitPalletSpace = this.getPalletSpace(
                this.product.width,
                this.product.length,
                this.product.quantity
            );
            let heightDivisor = Math.floor(maxHeight / this.product.height);
            let stackable = this.product.stackable && this.product.quantity > 1 ? heightDivisor : 1;

            let palletSpace = Math.ceil(unitPalletSpace / stackable);

            if (palletSpace > 0) {
                this.product.palletSpace = palletSpace;
            } else {
                this.product.palletSpace = 0;
            }
        } else {
            this.product.palletSpace = 0;
        }
    }

    deleteLine(index: number) {
        // clear validation error bag
        this.$validator.errors.clear();
        this.$store.dispatch('deleteLine', index);
    }

    removeProduct(index: number) {
        this.$emit('removeProduct', index);
    }

    addLineValidate(num: any) {
        if (!num) {
            return 'Required';
        } else {
            let check = (num + '').search(/[^a-zA-Z]+$/);
            if (check != 0) {
                return 'Invalid Format';
            }
            console.log(check);
        }

        return '';
    }

    @Watch('product.selectedProduct')
    onSelectProduct(val: string, oldVal: string, event: any) {
        let selectProductData = {
            tms_product_id: 0,
            tms_product_name: '',
            tms_product_description: '',
            tms_product_pallet_dimensions: '',
            tms_product_length: '',
            tms_product_width: '',
            tms_product_height: '',
            tms_product_quantity: '',
            tms_product_weight: '',
            tms_product_class: '',
            tms_product_stackable: 1,
        };
        Object.assign(
            selectProductData,
            this.productTemplates.find((item: any) => item.tms_product_id === val)
        );
        if (
            (this.product.showDetail && this.product.selectedPalletDimension) ||
            this.product.selectedProduct
        ) {
            this.product.weight = selectProductData.tms_product_weight;
            this.product.class = selectProductData.tms_product_class;
        }
        this.product.newProductName = selectProductData.tms_product_description;
        this.product.width = selectProductData.tms_product_width;
        this.product.length = selectProductData.tms_product_length;
        this.product.height = selectProductData.tms_product_height;
        this.product.quantity = selectProductData.tms_product_quantity;
        this.product.selectedPalletDimension = selectProductData.tms_product_pallet_dimensions;
        this.product.selectedProduct = selectProductData.tms_product_id;
    }

    showOrHideProductDetail(item: any) {
        if (!item.showDetail) {
            item.quantity = '';
            item.width = '';
            item.length = '';
            item.height = '';
            item.selectedPalletDimension = '';
            item.selectedProduct = '';
            item.isPalletsStackable = false;
            item.isSaveItemToProducts = false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/quote/components/shippingDetailTruckload/index.ts